import axios from 'axios';
import token from '@/store/token';

export default () => {
  return axios.create({
    baseURL: token.state.token ? '/admin' : '/api',
    timeout: 20000,
    headers: {
      Authorization: `Bearer ${token.state.token}`,
    },
  });
};
